import * as React from 'react';

import { DimeButton } from '../DimeButton.js';
import { TOOLBAR_CONTROL_CLASS } from '../lib/toolbar-control-class.js';
import { cn } from '../lib/utils.js';
import { withToolbarIconProps } from '../lib/with-toolbar-icon-props.js';
import type { DimeActionToolbarIcon, DimeActionToolbarTone } from './DimeActionToolbar.types.js';

const TONE_CLASSES: Record<DimeActionToolbarTone, string> = {
  destructive: 'text-destructive',
  warning: 'text-amber-700 dark:text-amber-300',
};

type DimeActionToolbarButtonProps = Readonly<
  Omit<React.ComponentProps<typeof DimeButton>, 'children'> & {
    icon: DimeActionToolbarIcon;
    label: string;
    tone?: DimeActionToolbarTone;
    /** Marks a button that opens a menu with a small corner triangle. */
    hasMenu?: boolean;
  }
>;

export const DimeActionToolbarButton = React.forwardRef<
  HTMLButtonElement,
  DimeActionToolbarButtonProps
>(function DimeActionToolbarButton(
  { icon, label, tone, hasMenu = false, className, ...props },
  ref,
) {
  const toneClassName = tone ? TONE_CLASSES[tone] : undefined;
  return (
    <DimeButton
      ref={ref}
      variant="ghost"
      className={cn(TOOLBAR_CONTROL_CLASS, hasMenu && 'relative', className)}
      {...props}
    >
      {withToolbarIconProps(icon, toneClassName)}
      <span className={cn('text-xs leading-none font-medium', toneClassName)}>{label}</span>
      {hasMenu ? (
        <span
          aria-hidden
          data-slot="toolbar-menu-indicator"
          className="absolute right-0.5 bottom-0.5 size-0 border-2 border-transparent border-r-muted-foreground border-b-muted-foreground"
        />
      ) : null}
    </DimeButton>
  );
});
